import React from 'react';
export function Sidebar() {
  return <div className="flex flex-col items-center" style={{
    width: 275,
    height: 356,
    backgroundColor: '#F2F2F2',
    borderRadius: 1,
    fontFamily: 'Figtree, sans-serif',
    padding: '15px 16px'
  }} data-id="element-222">
      <h3 className="font-bold self-center" style={{
      fontSize: 20,
      lineHeight: '24px',
      color: '#003366'
    }} data-id="element-223">
        Mach Schluss mit müder Haut & Falten
      </h3>

      <img src="https://cdn.magicpatterns.com/uploads/nZdGi1cWcQ5BSiYYkyDa72/30_Rabatt_(6).jpg" alt="MaleUp 3x Anti-Aging Face Cream + GRATIS Augenserum" className="mt-5" style={{
      width: 200,
      height: 200,
      borderRadius: 4,
      objectFit: 'cover'
    }} data-id="element-224" />

      <a href="https://maleup.de/products/quiz-deal-3x-anti-aging-face-cream?variant=52835646537995" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center mt-4" style={{
      width: 242,
      height: 82,
      backgroundColor: '#1A1A1A',
      borderRadius: 5
    }} data-id="element-225">
        <span className="font-bold text-center text-white" style={{
        fontSize: 19,
        lineHeight: '28.5px'
      }} data-id="element-226">
          Jetzt 60€ Rabatt
          <br data-id="element-227" />
          sichern →
        </span>
      </a>
    </div>;
}